<template>
  <div>
    <!-- 请假状态 -->
    <van-nav-bar @click-right="onClickRight">
      <template #left>
        <div style="color: #333">预约审批状态</div>
      </template>
      <template #right>
        <div style="color: #646566">
          {{ selectText }}
          <van-icon name="arrow" color="#646566" />
        </div>
      </template>
    </van-nav-bar>

    <!-- 审批状态选择弹窗 -->
    <van-action-sheet v-model="approvalShow" :actions="actions" @cancel="onCancel" cancel-text="取消"
      @select="onSelect" />
    <van-list v-model="loading" ref="list" v-if="todoAuditList.length > 0" class="list" :error.sync="error"
      :immediate-check="false" error-text="请求失败，点击重新加载" @load="onLoad">
      <div class="list-item" v-for="item in todoAuditList" :key="item.id" @click="handleVisItem(item.id)">
        <div class="top">
          <!-- <span class="status todo">待审批</span> -->
          <van-tag plain type="primary" size="medium" v-if="item.auditStatus == 0">待审批</van-tag>
          <van-tag plain type="success" size="medium" v-if="item.auditStatus == 1">已通过</van-tag>
          <van-tag plain type="danger" size="medium" v-if="item.auditStatus == 2">已驳回</van-tag>
          <van-tag plain type="danger" size="medium" v-if="item.auditStatus == -1">已过期</van-tag>
          <!-- 预约时间 old-->
          <!-- <span class="top-text">{{ item.resttime }} {{ item.startTime }} - {{ item.endTime }}</span> -->

          <!-- 预约时间 new -->
          <span class="top-text">{{ setVisitorTime(item.visitorStartTime, item.visitorEndTime) }}</span>


        </div>
        <div class="content">
          <div class="avatar">
            <img :src="item.userPhoto ? item.userPhoto : item.avatar" alt="" />
          </div>
          <div class="info">
            <div class="info-1">
              <div>
                {{ item.initiatorName }} <span @click.stop="getTeacherOrParentMobile(item, item.isShowMobile)">{{ item.isShowMobile ? item.noMobile : item.initiatorPhone }}</span>
                <van-icon style="text-indent: 0;font-size: 15px;margin-left: 3px;"
                  @click.stop="getTeacherOrParentMobile(item, item.isShowMobile)" v-if="!item.isShowMobile" name="eye-o" />
                <van-icon style="text-indent: 0;font-size: 15px;margin-left: 3px;"
                  @click.stop="getTeacherOrParentMobile(item, item.isShowMobile)" v-if="item.isShowMobile"
                  name="closed-eye" />
              </div>
              <div class="btn" @click.stop="handleAuditBtn(item)" v-if="item.auditStatus == 0 && item.status == 0">
                审批
              </div>
            </div>
            <div class="info-2" v-if="item.affiliatedUnit">
              {{ item.affiliatedUnit }}
            </div>
          </div>
        </div>
        <div class="count" v-if="item.visitorName && item.visitorName.length > 0">
          共计{{ item.visitorName && item.visitorName.length + 1 }}人：<span class="" v-for="(v, index) in item.visitorName"
            :key="index">{{ v
            }}<span v-if="index !== item.visitorName.length - 1">
              /
            </span></span>
        </div>
      </div>
    </van-list>

    <div v-else>
      <van-empty description="暂无数据" />
    </div>

    <!-- <div class="list" v-if="auditType == 0">
      <div class="todo-list" v-if="todoAuditList.length > 0">
        <div
          class="todo-list-item flex flex-vc"
          v-for="item in todoAuditList"
          :key="item.id"
          @click="handleVisItem(item.id)"
        >
          <div class="todo-left flex">
            <div
              class="todo"
              :style="`background-image:url(${item.userPhoto})`"
            ></div>
            <div class="date">{{ item.resttime }}</div>
            <div class="date-course">
              {{ item.startTime }} - {{ item.endTime }}
            </div>
          </div>
          <div class="todo-content flex-1">
            <div class="flex">
              <div>
                <span>{{ item.affiliatedUnit }}</span>
              </div>
            </div>
            <div class="info">
              {{ item.initiatorName }} {{ item.initiatorPhone }}
            </div>
            <div
              class="avatar"
              v-if="item.visitorName && item.visitorName.length > 0"
            >
              共计{{ item.visitorName && item.visitorName.length + 1 }}人：<span
                class=""
                v-for="(v, index) in item.visitorName"
                >{{ v
                }}<span v-if="index !== item.visitorName.length - 1">
                  /
                </span></span
              >
            </div>
          </div>
          <div class="todo-btn" @click.stop="handleAuditBtn(item)">审批</div>
        </div>
      </div>
      <div v-else>
        <van-empty description="暂无数据" />
      </div>
      <div class="do-list-wrap" v-if="doList.length > 0">
        <div class="do-title">已通过</div>
        <div class="todo-list">
          <div
            class="todo-list-item flex flex-vc"
            v-for="item in doList"
            :key="item.id"
            @click="handleVisItem(item.id)"
          >
            <div class="todo-left flex">
              <div
                class="todo"
                :style="`background-image:url(${item.userPhoto})`"
              ></div>
              <div class="date">{{ item.resttime }}</div>
              <div class="date-course">
                {{ item.startTime }} - {{ item.endTime }}
              </div>
            </div>
            <div class="todo-content flex-1">
              <div class="flex">
                <div>{{ item.affiliatedUnit }}</div>
              </div>
              <div class="info">
                {{ item.initiatorName }} {{ item.initiatorPhone }}
              </div>
              <div
                class="avatar"
                v-if="item.visitorName && item.visitorName.length < 0"
              >
                共计{{ item.visitorName && item.visitorName.length }}人：<span
                  class=""
                  v-for="(v, index) in item.visitorName"
                  :key="index"
                  >{{ v
                  }}<span v-if="index !== item.visitorName.length - 1">
                    /
                  </span></span
                >
              </div>
            </div>
            <div class="do-btn">通过</div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- 已审批 -->
    <!-- <div class="list" v-if="auditType == 1">
      <div class="todo-list" v-if="todoAuditList.length > 0">
        <div
          class="todo-list-item flex"
          v-for="(item, index) in todoAuditList"
          :key="index"
        >
          <div class="todo-left">
            <div class="date">{{ item.resttime }}</div>
            <div class="date-course">
              {{ item.startTime }} - {{ item.endTime }}
            </div>
          </div>
          <div class="todo-content flex-1">
            <div class="flex">
              <div>{{ item.affiliatedUnit }}</div>
            </div>
            <div class="info">
              {{ item.acceptName }} {{ item.initiatorPhone }}
            </div>
          </div>
        </div>
      </div>
      <div v-else class="todo-list">
        <van-empty description="暂无数据" />
      </div>
    </div> -->


    <!-- 驳回审批弹窗 -->
    <van-dialog v-model="show" show-cancel-button close-on-click-overlay confirm-button-text="通过"
      cancel-button-text="驳回" cancel-button-color="#000" confirm-button-color="#000" @confirm="audit(1)"
      @cancel="audit(2)">
      <div class="dialog-wrap">
        <div class="title">{{ dialogMsg }}</div>
        <input type="text" class="remark-input" placeholder="备注" v-model="remark" @change="test" />
        <div v-if="columns.length > 0">
          <div class="dialog-item-title">审批人</div>

          <div class="cell-wrap">
            <div class="cell-wrap_item" @click.stop="handelClickAudit(item, index)"
              v-for="(item, index) in nowAuditList" :key="item.id">
              <!-- 删除图标 -->

              <div class="audit_close" v-if="item.auditStatus == 0 && isShowClose(index)"
                @click.stop="nowAuditList.splice(index, 1)">
                <van-icon name="cross" />
              </div>

              <!-- 通过图标 -->
              <div class="audit_allow" v-if="item.auditStatus == 1">
                <van-icon name="success" />
              </div>

              <img :src="item.avatar" alt="" />
              <span>{{ item.name }}</span>

            </div>
            <div class="cell-wrap_add" @click.stop="() => {
      nowAuditIndex = undefined;
      $refs.interviewee.showiIntervieweePopup = true
    }">
              <van-icon name="plus" />
            </div>
          </div>
        </div>
      </div>
    </van-dialog>

    <!-- 选择审批人弹窗 -->

    <!-- <van-popup
      v-model="showSelectPerson"
      round
      position="bottom"
      :style="{ height: '40%' }"
    >
      <van-picker
        show-toolbar
        title="选择审批人"
        :columns="columns"
        @confirm="handleConfirm"
        ref="picker"
        @cancel="showSelectPerson = false"
        value-key="name"
      />
    </van-popup> -->
    <Interviewee ref="interviewee" @selectItem="handleSelIntervieweeItem" pageType="teacher" />
  </div>
</template>

<script>
import moment from 'moment'
// 导入选择审批人弹窗
import Interviewee from "@/components/subScribePopup/interviewee";
moment.locale('zh-cn')

export default {
  components: {
    Interviewee
  },
  data() {
    return {
      todoAuditList: [],
      doList: [],
      auditType: 0,
      show: false,
      dialogMsg: '',
      remark: '',
      id: '',
      showSelectPerson: false,
      columns: [],
      pickerItem: {},
      data: {},
      nowAuditIndex: undefined,
      // 当前审批人列表
      nowAuditList: [],
      deptList: [],
      // 选中的状态
      selectText: "全部",
      // 审核状态弹窗显示参数
      approvalShow: false,
      // 审批状态列表
      actions: [{
        name: '全部'
      }, {
        name: '待审批'
      }, {
        name: '已通过'
      }, {
        name: '已驳回'
      }, {
        name: '已过期'
      }
      ],
      error: false,
      // 当前预约总页数
      totalPageNum: '',
      // 当前预约页数
      pageNum: 1,
      // 控制滚动
      loading: false,
      finished: false

    }
  },
  mounted() {
    this.getList()
    // 获取所有员工
    this.getUserDeptListAll()
  },
  methods: {
    test(e) {
      console.log('baihuz', e)
    },
    onCancel() {
      console.log('this.loading', this.loading)
      this.loading = false
    },


    // 点击显示选择状态 
    onClickRight() {
      this.approvalShow = true
    },


    // 选择请假状态后
    async onSelect(item) {
      this.error = false
      console.log('选择请假状态')
      if (this.$refs.list) {
        this.$refs.list.finished = false
      }
      this.finish = false
      this.pageNum = 1

      if (this.$refs.list) {
        this.$refs.list.finished = false
      }
      let obj = {
        待审批: 0,
        已通过: 1,
        已驳回: 2,
        已过期: -1,
        全部: ''
      }
      // 获取预约记录
      let reservation = await this.getVisitorAuditList(obj[item.name], 1)
      // 设置请假列表 
      this.totalPageNum = reservation.totalPage

      // 设置预约列表
      if (reservation.list) {
        this.todoAuditList = reservation.list
      }
      this.approvalShow = false
      this.selectText = item.name

    },

    // 滚动加载方法
    async onLoad() {
      console.log('--------------')
      let obj = {
        待审批: 0,
        已通过: 1,
        已驳回: 2,
        已过期: -1,
        全部: ''
      }

      console.log('当前页和总页数', this.pageNum, this.totalPageNum)
      // 数据加载完毕 
      if (this.pageNum == this.totalPageNum) {
        this.finished = true
        this.loading = false
      } else if (this.loading && this.pageNum !== this.totalPageNum) {
        this.finished = false
        // 获取下一页数据
        let newList = await this.getVisitorAuditList(obj[this.selectText], this.pageNum + 1)
        console.log('获取到下一页的数据')
        if (!newList) {
          this.error = true
          this.loading = false
          console.log('进来了吗')
          return
        }
        this.todoAuditList = [...this.todoAuditList, ...newList.list]
        this.pageNum = this.pageNum + 1
        this.totalPageNum = newList.totalPage
        this.loading = false
      }
    },
    getTeacherOrParentMobile(data, bol) {
      if (!data.noMobile) { // 没有手机号
        this.$https.getVisitorMobile({
          id: data.id
        }).then(res => {
          if (res.code == 200) {

            data.noMobile = res.data
            data.isShowMobile = !bol

          } else {
            this.$toast(res.msg)
          }
        })
      } else { // 有手机号
        data.isShowMobile = !bol
      }
    },
    // 对预约时间进行设置
    setVisitorTime(start, end) {
      let startTime = moment(start).format('YYYY.MM.DD')
      let endTime = moment(end).format('YYYY.MM.DD')

      let startYear = moment(start).format('YYYY')
      let endYear = moment(end).format('YYYY')

      if (startTime == endTime) { // 同天审批
        return `${moment(start).format('YYYY.MM.DD HH:mm')} - ${moment(end).format('HH:mm')}`
      } else { // 跨天审批
        if (startYear == endYear) { //不跨年
          return `${moment(start).format('YYYY.MM.DD HH:mm')} - ${moment(end).format('MM.DD HH:mm')}`
        } else { // 跨年
          return `${moment(start).format('YYYY.MM.DD HH:mm')} - ${moment(end).format('YYYY.MM.DD HH:mm')}`
        }
      }
    },


    // 获取选中的审批人信息
    handleSelIntervieweeItem(item) {
      console.log('item', item)
      // 判断有无当前审批人
      if (this.nowAuditList.some(x => x.id == item.id)) {
        this.$toast('当前审批人已存在，请勿重复添加')
        return
      }

      // 判断是添加还是修改人员
      if (this.nowAuditIndex == undefined) {
        this.nowAuditList.push({
          id: item.id,
          avatar: item.avatar,
          name: item.name,
          auditStatus: 0
        })
      } else {
        this.nowAuditList.splice(this.nowAuditIndex, 1, {
          id: item.id,
          avatar: item.avatar,
          name: item.name,
          auditStatus: 0
        })
      }

      this.pickerItem = item;
    },

    // 获取审批数据列表
    async getList() {
      this.todoAuditList = []
      let obj = {
        待审批: 0,
        已通过: 1,
        已驳回: 2,
        已过期: -1,
        全部: ''
      }
      // 获取预约记录
      let newList = await this.getVisitorAuditList(obj[this.selectText], 1)
      this.pageNum = 1
      this.totalPageNum = newList.totalPage
      if (newList.list) {
        this.todoAuditList = newList.list
      }
    },
    // 获取审核状态
    async getVisitorAuditList(auditType = 0, pageNum = 1) {
      const { data, code, msg } = await this.$https.getVisitorAuditList({
        auditType,
        userId: this.$store.state.userId,
        pageNum,
        pageSize: 10
      })
      if (code != 200) {
        return false
      }
      if (data.list && data.list.length > 0) {
        data.list.forEach(item => {
          item.isShowMobile = false
        })
      }
      return data
    },





    async getAuditList(type) {
      const { data, code, msg } = await this.$https.getAuditList({
        auditType: type,
        userId: this.$store.state.userId,
      })
      if (code !== 200) {
        this.$toast(msg)
        return false
      }
      return Promise.resolve(data)
    },


    // 点击跳转访客详情
    handleVisItem(id) {
      this.$router.push({ path: '/detailSub', query: { id, type: 'approval' } })
    },



    // 点击审批和驳回按钮
    async handleAuditBtn(item) {
      console.log('item----------', item)


      // 获取当前记录的详细信息
      const { data, code } = await this.$https.getVisitorDetail({
        visitorId: item.id,
      });
      if (code !== 200) {
        this.$toast("获取详情失败");
        return false;
      }


      this.data = data
      console.log('this.deptList', this.deptList)
      this.data.busAuditLevelList.forEach((item) => {
        let obj = this.deptList.find(
          (person) => person.id == item.designatedPersonId
        );
        // 姓名
        item.name = obj.name;
        item.avatar = obj.avatar
        item.createdTime = item.createdTime && moment(item.createdTime).format("YYYY-MM-DD HH:mm");
      });


      this.nowAuditList = JSON.parse(JSON.stringify(this.data.busAuditLevelList.map(item => {
        return {
          id: item.designatedPersonId,
          auditStatus: item.auditStatus,
          avatar: item.avatar,
          name: item.name
        }
      })))

      console.log('nowAuditList', this.nowAuditList, this.data)
      this.show = true
      this.remark = ''
      this.id = item.id
      this.dialogMsg = `${item.initiatorName} ${this.data.affiliatedUnit ? '(' + this.data.affiliatedUnit + ')' : ''}来访，您是否审核通过？`
    },

    // 判断是否能删除审核人
    isShowClose(index) {
      let newIndex = this.nowAuditList.findIndex(x => x.id == this.$store.state.userId)
      return index > newIndex
    },


    // 点击审批人进行审批人更换
    handelClickAudit(item, index) {
      // 当前审批人只能修改自己之后的审批人信息
      // 获取当前审核人在列表中的位置
      let newIndex = this.nowAuditList.findIndex(x => x.id == this.$store.state.userId)
      console.log('newIndex', index)
      if (index > newIndex) {
        this.nowAuditIndex = index
        this.$refs.interviewee.showiIntervieweePopup = true;
      }
    },




    async audit(status) {
      if (status == 1) {
        this.$toast({
          type: 'loading',
          message: '审批中...',
          overlay: true,
          duration: 0,
          forbidClick: true,
        })
      } else {
        this.$toast({
          type: 'loading',
          message: '驳回中...',
          overlay: true,
          duration: 0,
          forbidClick: true,
        })
      }

      const { code, msg } = await this.$https.audit({
        auditStatus: status,
        acceptId: this.$store.state.userId,
        visitorId: this.id,
        auditIds: status == 1 ? this.nowAuditList.map(item => item.id) : this.data.busAuditLevelList.map(x => x.designatedPersonId),
        remark: this.remark,
      })
      if (code !== 200) {
        this.$toast(msg)
        return false
      }
      if (status == 1) {
        // const res = await this.$https.getAuditStatus({
        //   visitId: this.id,
        // })
        // if (res.code !== 200) {
        //   this.$toast(res.msg)
        //   return
        // }
        this.$toast('审批通过')
      } else {
        this.$toast('驳回成功')
      }


      this.getList()
    },


    async getUserDeptListAll() {
      const { data } = await this.$https.getUserDeptListAll({
        schoolId: this.$store.state.schoolId,
      })
      if (data.length == 0) {
        // this.$toast('搜索不到当前人员，请检查后重试')
        return false
      }
      this.deptList = data
      let filterData = data.filter(
        (item) => item.id !== this.$store.state.userId
      )
      let obj = {}
      filterData.forEach((item) => {
        if (!obj[item.deptName]) {
          obj[item.deptName] = []
        }
        obj[item.deptName].push(item)
      })
      let columns = []
      for (const key in obj) {
        columns.push({
          name: key,
          children: obj[key],
        })
      }
      this.columns = columns
      console.log(columns)
    },


    handleConfirm(value, indexs) {
      console.log(value, indexs, "审批详情");
      const columns1 = this.$refs.picker.getColumnValues(1)
      console.log('columns1', columns1)
      this.pickerItem = columns1[indexs[1]]
      console.log('pickerItem', this.pickerItem)
      this.showSelectPerson = false
    },
  },
}
</script>

<style lang="scss" scoped>
.list {
  /* padding: 1.5rem 0; */
  margin: 1rem;

  .list-item {
    display: flex;
    flex-direction: column;
    background: #fff;
    margin-bottom: 0.63rem;
    border-radius: 0.75rem;
    position: relative;

    &::after,
    &::before {
      content: '';
      width: 1rem;
      height: 1rem;
      background: #f7f7fa;
      border-radius: 50%;
      position: absolute;
      top: 2.6rem;
    }

    &::after {
      right: -0.5rem;
    }

    &::before {
      left: -0.5rem;
    }

    .top {
      padding: 0.88rem 0;
      margin: 0 0.75rem;
      border-bottom: 1px dashed #d9dee9;
      font-size: 1rem;

      /* .status {
        background: rgba(52, 151, 253, 0.13);
        border-radius: 50%;
        color: #3497fd;
        display: inline-block;
        width: 1.5rem;
        height: 1.5rem;
        text-align: center;
        line-height: 1.5rem;
        font-size: 0.75rem;
      } */
      .top-text {
        display: inline-block;
        vertical-align: middle;
        margin-left: 1.31rem;
        font-size: 0.88rem;
        color: #78849e;
      }
    }

    .content {
      margin: 0 0.75rem;
      padding: 0.81rem 0;
      display: flex;
      align-items: center;

      .avatar {
        width: 2.88rem;
        height: 2.88rem;
        margin-right: 0.81rem;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 50%;
        }
      }

      .info {
        flex: 1;
        color: #959dad;

        .info-1 {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 0.88rem;

          .btn {
            background: rgba(52, 151, 253, 0.13);
            color: #3497fd;
            width: 3.88rem;
            height: 1.56rem;
            border-radius: 2rem;
            text-align: center;
            line-height: 1.56rem;

            font-size: 0.81rem;
          }
        }
      }
    }

    .count {
      color: #959dad;
      margin: 0 0.75rem;
      font-size: 0.75rem;
      padding-bottom: 0.81rem;
    }
  }
}

.visitor {

  /* padding-bottom: 50pxpad; */
  .visitor-top {
    height: 6.1875rem;
    background: rgba(42, 46, 67, 1);
    width: 100%;
  }

  .visitor-content {
    /* margin-top: -4.875rem; */
    padding: 0 0.5625rem;

    .post {
      .post-item {
        background: rgba(53, 58, 80, 1);
        border-radius: 0.5rem;
        width: 10.75rem;
        height: 2.5625rem;
        padding: 0 1rem;

        &.active {
          background: rgba(58, 204, 225, 1);
          color: #ffffff;

          .iconActive {
            color: #ffffff;
          }

          .text {
            color: #ffffff;
          }
        }

        .iconfont {
          color: rgba(255, 255, 255, 0.56);
          font-size: 1rem;
        }

        .count {
          font-size: 1.125rem;
        }

        .text {
          margin-left: 0.75rem;
          color: rgba(255, 255, 255, 0.56);
          font-size: 0.75rem;
        }

        img {
          width: 1.1rem;
          height: 1.1rem;
          object-fit: cover;
        }
      }
    }
  }

  .do-title {
    color: #78849e;
    font-size: 0.75rem;
    margin: 1rem;
  }

  .do-list-wrap {
    margin-top: 0.8125rem;

    .do-list {
      background: #fff;
      border-radius: 1.0625rem;
      margin: 0 1rem;
      /* margin-top: 0.8125rem; */
      /* padding: 1.5rem 0; */
    }
  }

  .todo-list {
    background: #fff;
    border-radius: 1.0625rem;
    margin-top: 0.8125rem;
    padding: 1.5rem 0;
    margin: 0 1rem;

    .todo-list-item {
      margin-bottom: 1.5rem;
      padding: 0 0.75rem;
      color: rgba(149, 157, 173, 1);
      position: relative;

      &:last-child {
        margin-bottom: 0;
      }

      .todo-left {
        flex-direction: column;
        align-items: center;

        .todo {
          /* background: rgba(52, 151, 253, 1); */
          background-size: 100% 100%;
          background-repeat: no-repeat;

          width: 2rem;
          height: 2rem;
          color: #fff;
          text-align: center;
          line-height: 1.5rem;
          font-size: 0.75rem;
          border-radius: 50%;
          margin-bottom: 0.625rem;

          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            object-fit: cover;
          }
        }

        .date {
          margin-bottom: 0.3125rem;
          font-size: 0.75rem;
          font-weight: 400;
          color: rgba(120, 132, 158, 1);
        }

        .date-course {
          font-size: 0.5625rem;
        }
      }
    }

    .todo-content {
      font-size: 0.75rem;
      font-weight: 400;
      margin-left: 0.5rem;

      .info {
        margin-top: 0.25rem;
      }

      .avatar {
        margin-top: 0.4875rem;
        /* text-overflow; */
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        max-width: 12rem;
      }

      img {
        width: 2rem;
        height: 2rem;
        border-radius: 50%;
        margin-right: 0.5rem;
        object-fit: cover;
      }
    }

    .todo-btn {
      width: 2.6875rem;
      height: 2.6875rem;
      text-align: center;
      line-height: 2.6875rem;
      font-size: 0.75rem;
      border-radius: 0.5rem;
      color: #fff;
      margin-left: 0.3rem;
      box-shadow: 0 0.75rem 1rem rgba(69, 91, 99, 0.1);
      background: #3acce1;

      /* margin-right: 0.75rem; */
    }

    .do-btn {
      position: absolute;
      width: 3rem;
      height: 1.875rem;
      border: 1px solid #3acce1;
      color: #3acce1;
      text-align: center;
      line-height: 1.875rem;
      right: 1rem;
      font-size: 0.8rem;
      transform: rotate(30deg);
    }
  }
}

.remark-input {
  background: #f7f7fa;
  border: none;
  padding: 10px 15px;
  width: 100%;
  border-radius: 20px;
  margin: 10px 0;
}

.dialog-item-title {
  color: #333;
  //   font-size: 12px;
  margin: 10px 1rem;
}

.cell-wrap {
  padding: 10px 15px 0;
  border-radius: 10px;
  display: flex;
  flex-wrap: wrap;

  .cell-wrap_item {
    // background-color: pink;
    margin-right: 1.8rem;
    margin-bottom: 1rem;
    display: flex;
    color: #c7c7c7;
    position: relative;
    align-items: center;
    flex-direction: column;

    .audit_close {
      position: absolute;
      top: 0;
      right: 0;
      width: 1rem;
      height: 1rem;
      text-align: center;
      line-height: 1rem;
      font-size: 0.6rem;
      background-color: #bac6d0;
      color: #fff;
      border-radius: 50%;
    }

    .audit_allow {
      position: absolute;
      top: 0;
      right: 0;
      width: 1rem;
      height: 1rem;
      text-align: center;
      line-height: 1rem;
      font-size: 0.6rem;
      background-color: #07c160;
      color: #fff;
      border-radius: 50%;
    }

    &::before {
      content: ". . .";
      position: absolute;
      color: #c7c7c7;
      height: 0.5rem;
      line-height: 0.1rem;
      top: 34%;
      transform: translateY(-50%);
      right: -1.5rem;
    }

    img {
      width: 4.4rem;
      height: 4.4rem;
      border-radius: 50%;
      background-color: #fff;
      margin-bottom: 0.3rem;
    }

    &:nth-child(3n) {
      margin-right: 0;
    }

    &:nth-child(3n)::before {
      color: transparent;
    }
  }

  .cell-wrap_add {
    width: 4.4rem;
    height: 4.4rem;
    border-radius: 50%;
    color: #c7c7c7
      /* 33/9.59 */
    ;
    margin-bottom: 1rem;
    line-height: 4.4rem;
    text-align: center;
    font-size: 1.8rem;
    border: 1px solid #c7c7c7;
  }
}

.dialog-wrap {
  padding: 10px;

  .title {
    text-align: center;
    margin: 1rem 0;
    //   color: red;
  }
}
</style>
